import React from "react";
import { Link } from "react-router-dom";
import { tag_post } from "./data";
function Tag_sidebar(){
    return(
        <div className="tag-post sidebar-widget">
            <h2>برچسب ها</h2>
            <div className="tags">
            {
                tag_post.map((tag)=>{
                    return(
                        <Link to="tag" key={tag.id}>{tag.title}</Link>
                    );
                })
            }
            </div>
        </div>
    );
}

export default Tag_sidebar;